import {
  faBootstrap,
  faCss3Alt,
  faHtml5,
  faJs,
  faNode,
  faReact,
} from '@fortawesome/free-brands-svg-icons'
import { faDatabase } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import { Card, Col, Row } from 'react-bootstrap'
import './About.css'

const About = () => {
  return (
    <div
      data-aos='zoom-in'
      data-aos-easing='ease-out-cubic'
      data-aos-duration='1000'
      id='about'
    >
      <Card className='about-me m-auto mt-5' style={{ width: '90%' }}>
        <Card.Body>
          <p className='section-title'>About Me </p>

          <Card.Text style={{ textAlign: 'justify' }}>
            At the very beginning of my university study, I started to learn
            programming. Now I am learning different frontend technologies. I am
            very enthusiastic to learn more about modern innovative technology
            to accelerate my IT knowledge and skills. I am a very much
            responsible person for my work and try my level best to achieve my
            goal through dynamism and dedication.
          </Card.Text>
          <div id='skill'>
            <h6 className='fw-bold mt-5 g-2'>
              Here are a few technologies I’ve been working with recently:{' '}
            </h6>
            <Row className='mt-4'>
              <Col xs={12} sm={6} md={3}>
                <FontAwesomeIcon icon={faHtml5}></FontAwesomeIcon> HTML5
              </Col>
              <Col xs={12} sm={6} md={3}>
                <FontAwesomeIcon icon={faCss3Alt}></FontAwesomeIcon> CSS3
              </Col>
              <Col xs={12} sm={6} md={3}>
                <FontAwesomeIcon icon={faBootstrap}></FontAwesomeIcon> Bootstrap
              </Col>
              <Col xs={12} sm={6} md={3}>
                <FontAwesomeIcon icon={faJs}></FontAwesomeIcon> JavaScript
              </Col>
              <Col xs={12} sm={6} md={3}>
                <FontAwesomeIcon icon={faReact}></FontAwesomeIcon> React JS
              </Col>
            </Row>
          </div>
        </Card.Body>
      </Card>
    </div>
  )
}

export default About
